import {
  CircularProgress,
  LinearProgress,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { Box } from "@mui/system";
import React from "react";
import { StyledButton } from "../../common/components/Button";
import { GlobalContainer } from "../../common/components/Container";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { forgotPassword } from "../../api/authApi";
import { useState } from "react";

const ForgotPassword = () => {
  const [isSubmitting, setSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    resolver: yupResolver(
      yup.object().shape({
        email: yup
          .string()
          .email("Must be a valid email.")
          .required("Email is required."),
      })
    ),
  });
  const navigate = useNavigate();

  const handleForgot = async (values) => {
    try {
      setSubmitting(true);
      const response = await forgotPassword(values.email);
      setSubmitting(false);
      console.log(response);
      navigate("/");
    } catch (err) {
      setSubmitting(false);
      setError("submission", {
        type: "custom",
        message: err.response.data.message,
      });
    }
  };

  return (
    <Box sx={{ width: "100vw", height: "100vh", backgroundColor: grey[200] }}>
      <GlobalContainer theme="purple">
        <Box
          maxWidth="sm"
          sx={{
            width: "100%",
            margin: "0 auto",
            paddingX: 8,
          }}
        >
          <Box
            sx={{
              marginTop: 4,
              backgroundColor: "white",
              borderRadius: "15px",
              boxShadow:
                "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
            }}
          >
            <Box sx={{ padding: 2.5 }}>
              <form onSubmit={handleSubmit(handleForgot)}>
                <Typography
                  component="h1"
                  sx={{
                    fontSize: "1.25rem",
                    fontWeight: 600,
                  }}
                >
                  Find your account
                </Typography>
                <Typography sx={{ marginTop: 1, fontSize: "0.875rem" }}>
                  Enter the email address associated with your account to change
                  your password
                </Typography>
                <TextField
                  placeholder="Email"
                  fullWidth
                  sx={{ marginTop: 2 }}
                  {...register("email")}
                  error={Boolean(errors.email)}
                  helperText={errors.email?.message}
                />
                <Typography
                  sx={{
                    fontSize: "0.875rem",
                    color: red[400],
                    marginTop: 1,
                  }}
                >
                  {errors.submission?.message}
                </Typography>
                <Box sx={{ marginTop: 2, textAlign: "right" }}>
                  <Box sx={{ display: "inline-block" }}>
                    {isSubmitting && <CircularProgress />}
                    {!isSubmitting && (
                      <>
                        <Link
                          component={RouterLink}
                          sx={{ textDecoration: "none" }}
                          to="/"
                        >
                          <StyledButton theme="purple">Cancel</StyledButton>
                        </Link>
                        <StyledButton
                          theme="green"
                          type="submit"
                          sx={{ marginLeft: 1 }}
                        >
                          Submit
                        </StyledButton>
                      </>
                    )}
                  </Box>
                </Box>
              </form>
            </Box>
          </Box>
        </Box>
      </GlobalContainer>
    </Box>
  );
};

export default ForgotPassword;
